import React, { createContext, useEffect, useRef, useCallback } from 'react';
import { createSseTicket } from '../services/api';

export const RideEventsContext = createContext(null);

export function RideEventsProvider({ user, children }) {
  const listenersRef = useRef(new Set());

  useEffect(() => {
    if (!user) return;

    let es = null;
    let cancelled = false;

    async function connect() {
      const token = localStorage.getItem('taxi-token');
      if (!token || cancelled) return;
      try {
        const res = await createSseTicket();
        if (cancelled) return;
        const base = process.env.REACT_APP_API_URL || 'http://localhost:8080';
        es = new EventSource(`${base}/rides/events?ticket=${encodeURIComponent(res.data.ticket)}`);
        es.addEventListener('refresh', () => {
          listenersRef.current.forEach((fn) => fn());
        });
        es.onerror = () => {
          es.close();
          if (!cancelled) setTimeout(connect, 3000);
        };
      } catch {
        if (!cancelled) setTimeout(connect, 5000);
      }
    }

    connect();

    return () => {
      cancelled = true;
      if (es) es.close();
    };
  }, [user]);

  const subscribe = useCallback((fn) => {
    listenersRef.current.add(fn);
    return () => listenersRef.current.delete(fn);
  }, []);

  return <RideEventsContext.Provider value={subscribe}>{children}</RideEventsContext.Provider>;
}
